import { mix } from 'polished';

export const white: string = '#FFFFFF';
export const black: string = '#000000';

export const gray90 = mix(0.1, white, black);
export const gray80 = mix(0.2, white, black);
export const gray70 = mix(0.3, white, black);
export const gray60 = mix(0.4, white, black);
export const gray50 = mix(0.5, white, black);
export const gray40 = mix(0.6, white, black);
export const gray30 = mix(0.7, white, black);
export const gray20 = mix(0.8, white, black);
export const gray15 = mix(0.85, white, black);
export const gray10 = mix(0.9, white, black);
export const gray05 = mix(0.95, white, black);

export const darken = (color: string, amount: number): string =>
  mix(Math.min(amount / 100, 1), black, color);

class Color {
  constructor(readonly base: string) {}

  toString(): string {
    return this.base;
  }
  lighter(amount: number): string {
    return mix(Math.min(amount / 100, 1), white, this.base);
  }
  darker(amount: number): string {
    return darken(this.base, amount);
  }
}

export const yellow = new Color('#FFE27A');
export const green = new Color('#24DE67');
// TBD new orange brand base color
export const orange = new Color('#FF6500');
export const red = new Color('#FF462E');

export const lightGreen = new Color('#90EEB1');
export const darkGreen = new Color('#003816');
export const dough = new Color('#F4EADD');

// Semantic colors
export const brandPrimary: string = green.darker(50);
export const facebookColor: string = '#1877f2';
export const googleColor: string = '#3f3f3f';
export const appleColor: string = '#000000';
export const yellowPrimary: string = '#FFD951';
export const yellowPrimaryDarker: string = '#fad13c';
export const orderSummaryAlert: string = yellow.base;
export const brandDarkGreen: string = green.darker(60);
export const warningRed: string = red.darker(20);

// Backgrounds
export const backgroundSuccess: string = green.lighter(80);
export const backgroundWarning: string = orange.lighter(80);
export const backgroundError: string = red.lighter(80);

// Text colors
export const textDefault: string = gray90;
export const textBrand: string = green.darker(20);
export const textSecondary: string = gray60;
export const textDisabled: string = gray40;
export const textSuccess: string = green.darker(50);
export const textWarning: string = orange.darker(20); // More contrast would be needed for orange text's accessibility
export const textError: string = red.darker(20);
export const textWhite: string = white;

// Borders
export const borderDefault: string = gray20;
export const borderInput: string = gray30;
export const outlineDefault: string = green.darker(20);

// Links
export const linkDefault: string = green.darker(50);
export const linkHover: string = green.darker(70);

export const colors = {
  white,
  black,
  gray90,
  gray80,
  gray70,
  gray60,
  gray50,
  gray40,
  gray30,
  gray20,
  gray15,
  gray10,
  gray05,
  yellow,
  green,
  orange,
  red,
  lightGreen,
  darkGreen,
  dough,
  brandPrimary,
  facebookColor,
  googleColor,
  appleColor,
  yellowPrimary,
  yellowPrimaryDarker,
  orderSummaryAlert,
  brandDarkGreen,
  warningRed,
  backgroundSuccess,
  backgroundWarning,
  backgroundError,
  textDefault,
  textBrand,
  textSecondary,
  textDisabled,
  textSuccess,
  textWarning,
  textError,
  textWhite,
  borderDefault,
  borderInput,
  outlineDefault,
  linkDefault,
  linkHover,
};
